export enum userRoleEnum {
	TEACHER = 'teacher',
	STUDENT = 'student',
	ADMIN = 'admin',
	MENTOR = 'mentor'

}